require('./cardsToggleButton.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const TextToggle = require('components/commons/textToggle/textToggle');
// @ utilities
const { FormattedText } = require('core/i18n').i18n;

class CardsToggleButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false
        }

        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleClickOff = this.handleClickOff.bind(this);
        this.handleClickOn = this.handleClickOn.bind(this);
    }

    handleClickOff() {
        const { immCard, switchCardToggleOff } = this.props;

        return switchCardToggleOff(immCard.get('cardId'));
    }

    handleClickOn() {
        const { immCard, switchCardToggleOn } = this.props;

        return switchCardToggleOn(immCard.get('cardId'));
    }

    handleToggleModal() {
        this.setState({
            modalOpen: !this.state.modalOpen
        }, () => {
                this.props.resetCardToggle(this.state.modalOpen);
        });
    }
    buildDefaultModalContent() {
        return null;
    }
    render() {
        const { immCard, buildModalContent, tooltipOff, tooltipOnSubmit, description, cardFieldCheck, cardIndex } = this.props;
        const cardOn = immCard.get(cardFieldCheck);
        const modalContent = buildModalContent? buildModalContent.bind(this)() : this.buildDefaultModalContent();
        const tooltipText = cardOn ? tooltipOff : tooltipOnSubmit;

        const toogle = (
            <div>
                <TextToggle immCard={immCard} cardIndex={cardIndex+1} textCheck={'ON'} textUncheck={'OFF'} checked={cardOn} onClick={this.handleToggleModal} />
            </div>
        )

        const toggleWithTooltip = (this.state.modalOpen) ? toogle : (
            <OKTooltip
                content={tooltipText}
                offset={[0, -15]}
                target={toogle}
                type="descriptive"
            />
        )

        const toggleAndLabel = (
            <div className="cards-toggle-button__tooltip-container">
                <div className="cards-toggle-button__tooltip-container__tog">
                    {toggleWithTooltip}
                </div>
            </div>
        );

        const descriptionLabel = (
            <div className="cards-toggle-button__description-container">
                <FormattedText value={description}/>
            </div>
        )
        const controlButtonContent = (
            <span className="cards-toggle-button">
                { descriptionLabel }
                { toggleAndLabel }
                { modalContent }
            </span>
        );

        return controlButtonContent;
    }
}

CardsToggleButton.contextTypes = {
    router: PropTypes.object.isRequired
};

CardsToggleButton.propTypes = {
    immCard: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    cardFieldCheck: PropTypes.bool.isRequired,
    immCardToggle: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    resetCardToggle: PropTypes.func.isRequired,
    switchCardToggleOff: PropTypes.func.isRequired,
    switchCardToggleOn: PropTypes.func.isRequired,
    avoidCardControlButton: PropTypes.bool,
    description: PropTypes.isRequired,
    reducerStateName: PropTypes.string.isRequired,
    tooltipOff: PropTypes.string.isRequired,
    tooltipOnSubmit: PropTypes.string.isRequired,
    buildModalContent: PropTypes.func.isRequired,
    cardIndex: PropTypes.number
}

const mapStateToProps = (state, props) => {
    const { reducerStateName } = props;
    return {
        flagBasedFeatures: state.flagBasedFeatures,
        immCardToggle: state[reducerStateName]
    };
};

module.exports = connect(mapStateToProps)(CardsToggleButton);

